module.exports = __webpack_public_path__ + "media/assets/images/events/sanmarco_logo-c53ac417464489fd2385d9dd972836e5.png";